import { getSaldosEdificios } from "./getSaldoEdificio";

// Comisiones de edificios se liquidan trimestralmente (enero, abril, julio, octubre; día 15). El
// default se proyecta 2 trimestres adelante del trimestre actual = inicio del trimestre actual + 6
// meses, día 15. Estable DENTRO del trimestre: no depende de si el día 15 ya pasó (reemplaza el
// "AJUSTE TEMPORAL +3" que doble-postergaba una vez pasado el 15). Ej.: hoy en Q3 → 15/01 del año
// siguiente. new Date normaliza el desborde de mes (q0+6 > 11 → año siguiente).
const proximaFechaPago = () => {
  const hoy = new Date();
  const q0 = Math.floor(hoy.getMonth() / 3) * 3; // inicio del trimestre actual: 0, 3, 6 o 9
  const fecha = new Date(hoy.getFullYear(), q0 + 6, 15);
  return fecha.toISOString().split("T")[0];
};

/**
 * Wrapper delgado sobre getSaldosEdificios (fuente única de verdad). Devuelve los edificios con saldo
 * pendiente > 0 con el shape que consumen el modal "Pago a edificio" y el tab Edificios de FlujoCajaV2.
 *
 * saldoPendiente = saldo = recaudada − pagada (acumulado [2023-01-01 … hoy]). Antes este util calculaba
 * "generada del último trimestre desde FECHA_CORTE", lo que divergía del EECC; ahora comparten motor.
 * Los params fechaInicio/monedaLocal se mantienen por compatibilidad de firma (ya no truncan el rango).
 */
export const getEdificiosSaldoPendiente = async ({ pais, monedaLocal }) => {
  const saldos = await getSaldosEdificios({ pais });
  const proxFecha = proximaFechaPago();

  return saldos
    .filter((e) => e.saldo > 0)
    .map((e) => ({
      edificioId: Number(e.edificioId),
      edificioNombre: e.edificioNombre,
      debitoTotal: e.recaudada,
      creditoTotal: e.pagada,
      saldoPendiente: e.saldo,
      moneda: e.moneda || monedaLocal,
      proximaFecha: proxFecha,
    }))
    .sort((a, b) => b.saldoPendiente - a.saldoPendiente);
};
